import angular from 'angular';

BookingsController.$inject = [
    '$scope',
    'Club',
    'Court',
    'BookingFactory',
    '_',
    '$aside',
    'Time',
    '$timeout',
    'Analytics',
];

/* @ngInject */
function BookingsController(
    $scope,
    Club,
    Court,
    BookingFactory,
    _,
    $aside,
    Time,
    $timeout,
    Analytics,
) {
    var vm = this;
    vm.title = '';

    // View related
    vm.viewType = 'day'; // or days
    vm.isMenuCollapsed = true;
    vm.loading = true;

    vm.clubName = Club.name;
    vm.calendarSlotSize = Club.calendar_slot_size;

    // Limits
    vm.currentCourt = null;
    vm.courts = [];

    vm.ClubId = Club.id;

    // Configs;
    vm.backoffice_date = Time.moment().format('YYYY-MM-DD');

    vm.backoffice_onDateChange = function (newDate) {
        vm.backoffice_date = newDate;
        vm.date.current = Time.moment(newDate);
    };

    vm.date = {
        current: Time.date(),
        opened: false,
        toggle: function () {
            vm.date.opened = !vm.date.opened;
        },
        formats: {
            sameDay: '[Hoy], dddd DD [de] MMMM',
            nextDay: '[Mañana], dddd DD [de] MMMM',
            nextWeek: 'dddd DD [de] MMMM',
            lastDay: '[Ayer], dddd DD [de] MMMM',
            lastWeek: 'dddd DD [de] MMMM',
            sameElse: 'dddd DD [de] MMMM',
        },
        format: 'dd-MMMM-yyyy',
        options: {
            //dateDisabled: disabled,
            formatYear: 'yy',
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
            datepickerMode: 'day',
        },
        goTo: function (day) {
            switch (day) {
                case 'today':
                    vm.date.current = Time.date();
                    break;
                case 'past':
                    vm.date.current = Time.moment(vm.date.current).subtract(
                        1,
                        'days',
                    );
                    break;
                case 'future':
                    vm.date.current = Time.moment(vm.date.current).add(
                        1,
                        'days',
                    );
                    break;
            }
        },
    };

    // Methods
    vm.changeView = changeView;
    vm.selectCourt = selectCourt;

    vm.calendar = {
        start: Club.hours_open,
        end: Club.hours_close,
    };

    vm.events = {
        schedule: [],
        create: eventsCreateAside,
        edit: eventsEditAside,
    };

    vm.redirectToClubWebsite = function () {
        const clubId = Club.id;
        const origin = window.location.origin;

        // Local
        if (origin.includes('127.0.0.1') || origin.includes('localhost')) {
            window.open(
                `https://beta.atcsports.io/sportclub/${clubId}`,
                '_blank',
            );
            return;
        }

        // URL basada en el origen actual
        const finalUrl = `${origin}/sportclub/${clubId}`;
        window.open(finalUrl, '_blank');
    };

    $scope.$on('booking:notification', function (event, notification) {
        var booking = notification.data.booking,
            court = notification.data.court,
            date = Time.moment(booking.date);

        if (events.isDisplaying(date, booking.fixed, court.id)) {
            fetch(true);
        }
    });

    //////////////////
    /**
     * @property events
     * @type {Object}
     */
    var events = {
        /**
         * Open create aside popup
         * @method events.openCreateAside
         * @param  {Float} hour Hour in float
         * @param  {Court} court
         */
        openCreateAside: function (hour, day, court) {
            var aside = $aside.open({
                template: require('../../../views/booking/create.aside.html'),
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: 'BookingsCreateController',
                controllerAs: 'vm',
                bindToController: true,
                resolve: {
                    deps: {
                        day: day,
                        hour: hour,
                        court: court,
                        update: append,
                    },
                },
            });

            aside.result.then(angular.noop).catch(angular.noop);
        },

        /**
         * Open create aside popup
         * @method events.openEditAside
         * @param  {Object} event If editing
         * @param  {Object} row Row of table
         */
        openEditAside: function (day, booking) {
            var aside = $aside.open({
                template: require('../../../views/booking/edit.aside.html'),
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: 'BookingsEditController',
                controllerAs: 'vm',
                bindToController: true,
                resolve: {
                    deps: {
                        day: day,
                        booking: booking,
                        remove: remove.bind(null, booking),
                        update: angular.noop,
                        refresh: fetch,
                    },
                },
            });

            aside.result.then(angular.noop).catch(angular.noop);
        },

        // Fetching
        /**rt
         * @param  {boolean} silent Hide loading icon
         */
        fetchCourtBookings: function (court, silent) {
            vm.loading = !silent;
            if (!silent) vm.events.schedule = [];

            var range = events.getRange(vm.date.current);

            return court.api
                .customGET('bookings', range)
                .then(function (court) {
                    vm.events.schedule = BookingFactory.collect.days(
                        court,
                        range,
                    );
                    vm.loading = false;
                });
        },
        /**
         * Fetches the Bookings for the date.current in all the courts.
         * Updates the events.schedule
         * @method events.fetchDateBookings
         * @param {boolean} silent Hide loading icon
         */
        fetchDateBookings: function (silent) {
            vm.loading = !silent;
            if (!silent) vm.events.schedule = [];

            var day = Time.moment(vm.date.current);

            return Club.API.getList('bookings', {
                day: day.format('Y-MM-DD'),
            }).then(function (courts) {
                vm.events.schedule = BookingFactory.collect.courts(courts);
                vm.loading = false;
            });
        },
        /**
         * Returns the current selected court
         * @method events.getCourt
         * @param  {Object: events.schedule column} column
         * @return {Court}
         */
        getCourt: function (column) {
            if (vm.currentCourt) {
                return vm.currentCourt;
            } else {
                return column;
            }
        },
        /**
         * Returns the selected date
         * @method events.getDay
         * @param  {Object: events.schedule column} column
         * @return {Moment}
         */
        getDay: function (column) {
            if (vm.currentCourt) {
                return Time.moment(column.id);
            } else {
                return Time.moment(vm.date.current);
            }
        },

        isDisplaying: function (date, fixed, court_id) {
            var current = Time.moment(vm.date.current);
            if (vm.currentCourt) {
                // SINGLE COURT MODE
                if (court_id !== vm.currentCourt.id) {
                    return false;
                }

                // check actual columns
                var range = Time.rangeToArray(events.getRange(current));

                if (fixed) {
                    var day = date.day();
                    return !!_.find(range, function (mom) {
                        return mom.day() === day;
                    });
                } else {
                    return !!_.find(range, function (mom) {
                        return mom.isSame(date, 'day');
                    });
                }
            } else {
                if (fixed) {
                    return current.day() === Time.momentToDay(date);
                } else {
                    return Time.isSame(current, date, 'day');
                }
            }
        },

        getColumn: function (booking) {
            var current = Time.moment(vm.date.current),
                date = booking.getDate(),
                court_id = booking.getCourt().id;
            if (vm.currentCourt) {
                // SINGLE COURT MODE
                if (booking.getCourt().id !== vm.currentCourt.id) {
                    return false;
                }

                // check actual columns
                if (booking.isFixed()) {
                    return _.find(vm.events.schedule, function (col) {
                        return col.id.day() === date;
                    });
                } else {
                    return _.find(vm.events.schedule, function (col) {
                        return col.id.isSame(date, 'day');
                    });
                }
            } else {
                if (booking.isFixed()) {
                    if (current.day() !== date) {
                        return undefined;
                    }
                } else {
                    if (!Time.isSame(current, date, 'day')) {
                        return undefined;
                    }
                }
                return _.find(vm.events.schedule, function (col) {
                    return col.id === court_id;
                });
            }
        },

        /**
         * Returns a { start, end } object of String formatted dates with a 5 day period
         * @method getRange
         * @param  {Date} start
         * @param  {Number} period default=5 max=6
         * @return {Object} range
         */
        getRange: function (start, period) {
            var date = Time.moment(start),
                DAYS = period ? Math.min(6, period) : 5;

            return {
                start: date.format('Y-MM-DD'),
                end: date.add(DAYS, 'days').format('Y-MM-DD'),
            };
        },
    };

    ////////////////

    function eventsCreateAside(hour, column) {
        var day = events.getDay(column),
            court = events.getCourt(column);
        events.openCreateAside(hour, day, court);
    }

    function eventsEditAside(booking, column) {
        if (!booking.isReady()) return;

        var day = events.getDay(column);
        events.openEditAside(day, booking);
    }

    var fetch = _.throttle(_fetch, 1500);

    function _fetch(silent) {
        if (!vm.currentCourt) {
            events.fetchDateBookings(silent);
        } else {
            events.fetchCourtBookings(vm.currentCourt, silent);
        }
    }

    function append(payload, court) {
        var booking = BookingFactory.create(payload);
        booking.setCourt(court);

        var target,
            col = events.getColumn(booking);
        if (col === undefined) {
            return;
        }
        target = _.find(vm.events.schedule, {
            id: col.id,
        });

        if (target) {
            target.events.push(booking);
        }
    }

    function remove(booking) {
        booking.deleted = true;

        $timeout(function () {
            var target,
                col = events.getColumn(booking);
            if (col === undefined) {
                return;
            }

            _.remove(col.events, function (i) {
                return i.id === booking.id;
            });
        }, 100);
    }

    /**
     * Update title acording the selected view
     * @method updateTitle
     */
    function updateTitle() {
        var title = vm.dateStart;
        if (vm.currentCourt) {
            title = vm.currentCourt.name;
        }

        vm.title = title;
    }

    /**
     * Changes the view type and updates everything linked, like the title
     * @method changeView
     * @param  {String} viewType
     */
    function changeView(viewType) {
        vm.viewType = viewType;
        if (viewType === 'day') {
            vm.currentCourt = null;
        }

        vm.isMenuCollapsed = true;
        fetch();
        updateTitle();
    }

    /**
     * Selects a different court
     * @method selectCourt
     * @param  {Number} courtId
     */
    function selectCourt(court) {
        if (vm.currentCourt === court) {
            return;
        }

        vm.currentCourt = court;
        vm.loading = true;
        vm.events.schedule = [];

        vm.changeView('court');
    }

    function activate() {
        // Fetch courts
        Club.API.getList('courts', {
            full: true,
        })
            .then(function (payload) {
                vm.courts = Court.collect(
                    payload.filter((c) => c.state !== 0),
                    true,
                );

                // if (vm.courts.length === 1) {
                // selectCourt(vm.courts[0]);
                // } else {
                vm.changeView('day');
                // }
            })
            .catch(function (e) {
                //
            });

        $scope.$watch('vm.date.current', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                fetch();
            }
        });
        // $scope.$watch(
        //     () => vm.backoffice_date,
        //     function (newValue, oldValue) {
        //         console.log('cambio de fecha aqui new');
        //     },
        // );
    }

    activate();
}

export default BookingsController;
